import { fg } from '@atlaskit/platform-feature-flags';

import type { FilterId } from '../../filters';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { SalesforceIcon } from './icon';
import { SalesforceIconBorderless } from './icon-borderless';
import { SalesforceSearchResultIcon } from './search-result-icon';
import { buildSalesforce3PTypeFilterConfig } from './type-filter-config';

export const salesforceConfig: ThirdPartyConfig = {
	displayName: 'Salesforce',
	id: 'salesforce',
	resourceType: 'salesforce-connector',
	icon: get3PLogo(SalesforceIcon, 'Salesforce', 'medium'),
	iconBorderless: get3PLogo(SalesforceIconBorderless, 'Salesforce', 'small'),
	searchResultIcon: get3PLogo(SalesforceSearchResultIcon, 'Salesforce', 'large'),
	integrationAri: 'ari:cloud:platform::integration/salesforce',
	// Use a getter to evaluate lazily so that feature flags are evaluated when accessed, not at module load.
	// This allows for feature gate mocks in tests to work correctly.
	get typeFilterConfig() {
		return buildSalesforce3PTypeFilterConfig();
	},
	get filters(): FilterId[] {
		const baseFilters: FilterId[] = ['lastUpdated', 'onlyTitleMatch', 'lastUpdatedBy', 'createdBy'];
		// TODO SFV2-307: implement campaignStatus filter store + UI before enabling
		if (fg('rovo-fps-3p-ux-salesforce-new-filters-fe-changes')) {
			baseFilters.push('owner');
			baseFilters.push('opportunityStatus');
			baseFilters.push('closeDate');
		}
		if (fg('rovo-fps-3p-ux-salesforce-dynamic-stage-filter')) {
			baseFilters.push('salesforceStage');
		}
		if (fg('rovo-fps-3p-ux-salesforce-campaign-noun')) {
			baseFilters.push('campaignStatus');
		}
		// TODO SFV2-306: implement caseStatus filter store + UI before enabling
		// if (fg('rovo-fps-3p-ux-salesforce-case-noun')) {
		// 	baseFilters.push('caseStatus');
		// }
		return baseFilters;
	},
	requiresOauth: true,
	isEnabled: () => true,
};
